var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-10 ProductsGrid"},_vm._l((Array(_vm.items)),function(item){return _c('LoadingProductCard',{key:item})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }